module.exports = __webpack_public_path__ + "img/veer-312539524.f09d24ea.jpg";